import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSleigh, faCandyCane } from "@fortawesome/free-solid-svg-icons";
import ChristmasButton from "../../components/ChristmasButton";
import "../../styles/pages/nav.scss";
import AppState from "../../context/AppContext";
import CookieWarning from "../Cookies/CookieWarning";

export default function Header() {
  const auth = JSON.parse(sessionStorage.getItem("user"));
  const context = useContext(AppState);

  const logout = () => {
    sessionStorage.clear();
    context.logout();
    context.setUser({});
    window.location.assign("/login");
  };
  return (
    <div className="row mt-2">
      {!localStorage.getItem("cookiePolicyAccepted") && (
        <CookieWarning />
      )}
      <div className="col">
        <Link to="/">
          <div className="d-flex flex-column align-items-center">
            <FontAwesomeIcon className="logo" icon={faSleigh} />
            <p className="m-0 logoText">North Pole Post</p>
          </div>
        </Link>
      </div>
      <div className="col d-flex align-items-around justify-content-end navbar ">
        <Link className="nav-link" to="/letter-to-santa-parent">
          Letter to Santa
        </Link>
      </div>

      {auth ? (
        <div className="col d-flex align-items-center justify-content-center">
          <div className="col d-flex align-items-center justify-content-start">
            <div className="col">
              <Link className="nav-link" to="/gift-list">
                Gift List
              </Link>
            </div>
            <div className="col">
              <Link className="nav-link" to="/secret-santa">
                Secret Santa
              </Link>
            </div>
            <div className="col">
              <Link className="nav-link" to="/advent-calendar">
                Advent Calendar
              </Link>
            </div>
          </div>
          <ChristmasButton onClick={logout} text="Logout">
            Logout
          </ChristmasButton>
        </div>
      ) : (
        <>
          <div className="col d-flex align-items-center justify-content-start">
            <Link className="navbar nav-item" id="navbarColor03" to="/about-us">
              About Us
            </Link>
          </div>
          <div className="col d-flex align-items-center justify-content-center">
            <ChristmasButton icon={faCandyCane} to="/login" text="Login" />
          </div>
        </>
      )}
    </div>
  );
}
